// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-start-padding[data-v-6a63edd2]{margin-top:5.7rem}@media (max-width: 375px){.page-start-padding[data-v-6a63edd2]{margin-top:4.8rem}}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
